import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-actions-list',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './actions-list.component.html',
  styleUrls: ['./actions-list.component.scss']
})
export class ActionsListComponent {
  isPlaying: boolean = false;
  @Input() mailObject: string = "";
  @Input() path: string = "";
  private utterance: SpeechSynthesisUtterance | null = null;

  ngOnInit(): void {
    this.path = `${window.location.origin}${this.path}`
  }

  listen() {
    if (this.utterance) {
      if (window.speechSynthesis.paused) {
        window.speechSynthesis.resume();
        this.isPlaying = true;
      } else {
        window.speechSynthesis.pause();
        this.isPlaying = false;
      }
      return;
    }

    const container = document.querySelector('.it-page-sections-container');
    if (!container) {
      console.error('Container non trovato');
      return;
    }

    const titolo = document.querySelector('h1')?.textContent?.trim() || '';
    const sections = container.querySelectorAll('.it-page-section');
    let testoCompleto = titolo + '. ';

    sections.forEach(section => {
      const sectionTitle = section.querySelector('h2')?.textContent?.trim() || '';
      const sectionContent = section.querySelector('p')?.textContent?.trim() || '';
      testoCompleto += sectionTitle ? (sectionTitle + '. ') : '';
      testoCompleto += sectionContent + '. ';
    });

    this.utterance = new SpeechSynthesisUtterance(testoCompleto);
    this.utterance.onend = () => {
      this.isPlaying = false;
      this.utterance = null;
    };
    this.utterance.onerror = (event) => {
      console.error('Errore durante la lettura:', event);
      this.isPlaying = true;
      this.utterance = null;
    };

    this.isPlaying = true;

    //Add cancel() before speak() to fix chrome issue 
    window.speechSynthesis.cancel();
    window.speechSynthesis.speak(this.utterance);
  }

  print() {
    window.print();
  }
  ngOnDestroy() {
    if (this.isPlaying) {
      window.speechSynthesis.cancel();
      this.isPlaying = false;
      this.utterance = null;
    }
  }

}
